export const faqModule1 = {
  // other module props
  id: "072f95be-5d30-39dd-b3dc-6cf009391d9c",
  config: {
    header: {
      isTextInCaps: false,
      text: "How should I prepare for my interview and do you have any tips?",
      textColor: {
        label: "Black 4",
        value: "#444444",
      },
    },
    text: {
      text: "Straight after you apply you will receive an email from us letting you know we’ve received your application. About a week later, you’ll receive another email with an update on your application or asking you to book yourself in for a Zoom call. This can vary during busier periods but our recruiters are always working hard to respond to you as quickly as possible.",
      textColor: {
        label: "Silver",
        value: "#222222",
      },
    },
  },
};

export const faqModule2 = {
  // other module props
  id: "072f95be-5d30-39dd-b3dc-6cf009391d9c",
  config: {
    header: {
      isTextInCaps: false,
      text: "Does the antidisestablishmentarianism debate still influence modern policies?",
      textColor: {
        label: "Black 4",
        value: "#444444",
      },
    },
    text: {
      text: "While antidisestablishmentarianism remains a fascinating historical term tied to debates about the Church of England’s role in state affairs, its relevance in shaping modern policies has diminished significantly over time. Today, the concept is primarily studied in academic or linguistic contexts rather than being actively invoked in political discourse or governance. Nonetheless, its legacy persists as a reminder of past struggles over the separation of church and state, influencing the broader evolution of secular and religious dynamics in governance.",
      textColor: {
        label: "Silver",
        value: "#222222",
      },
    },
  },
};

export default { faqModule1, faqModule2 };
